import { auth } from "../firebase";

/**
 * Get headers with authentication token for API requests
 * @returns {Promise<Object>} Headers object with Authorization token
 */
const getAuthHeaders = async () => {
  const user = auth.currentUser;
  
  if (!user) {
    throw new Error("User not authenticated");
  }

  const token = await user.getIdToken();

  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
  };
};

export default getAuthHeaders;
